import React, { useEffect, useRef, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';

interface CopyButtonProps {
  value?: string | null;
  label: string;
  copiedLabel: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({ value, label, copiedLabel }) => {
  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    setIsCopied(false);
  }, [value]);

  if (!value) return null;

  const accessibleLabel = isCopied ? copiedLabel : label;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setIsCopied(true);

      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setIsCopied(false);
        timeoutRef.current = null;
      }, 1500);
    } catch {
      setIsCopied(false);
    }
  };

  return (
    <Tooltip title={accessibleLabel} arrow>
      <IconButton
        onClick={() => void handleCopy()}
        aria-label={accessibleLabel}
        size="small"
        sx={{ p: 0, width: 18, height: 18 }}>
        {isCopied ? <DoneIcon sx={{ fontSize: 16 }} /> : <ContentCopyIcon sx={{ fontSize: 16 }} />}
      </IconButton>
    </Tooltip>
  );
};
